import React from "react";
import { useTranslation } from "react-i18next";
import Icon from "../../components/AppIcon";
import Button from "../../components/ui/Button";
import Footer from "components/common/Footer";
import Header from "components/ui/Header2";

const AboutUs = () => {
  const { t } = useTranslation();

    const handlePhoneClick = () => {
    window.open(`tel:07772235662`, "_self");
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Main Content Sections */}
      <div className="w-full max-w-[1182px] mx-auto px-[20px] sm:px-[30px] lg:px-[40px] py-[60px] sm:py-[80px] lg:py-[100px]">
        <div className="flex flex-col gap-[60px] sm:gap-[80px] lg:gap-[100px]">
          {/* Our Story Section */}
          <section className="flex flex-col lg:flex-row gap-[40px] lg:gap-[60px] items-center">
            <div className="lg:w-1/2">
              <h2 className="text-[20px] sm:text-[24px] lg:text-[32px] font-svn-gilroy font-bold leading-[28px] sm:leading-[32px] lg:leading-[40px] text-global-text8 mb-[20px] sm:mb-[30px]">
                {t("من نحن ؟", { defaultValue: "من نحن ؟" })}
              </h2>
              <p className="text-[14px] sm:text-[16px] lg:text-[18px] font-svn-gilroy font-medium leading-[20px] sm:leading-[24px] lg:leading-[28px] text-global-text2 mb-[20px] sm:mb-[30px]">
                نحن تطبيق أليفي، ونفتخر بتقديم أفضل الخدمات والمنتجات لحيواناتك
                الأليفة والمحبوبة في تطبيق أليفي نؤمن بأن الحيوانات الأليفة هي
                جزء لا يتجزأ من عائلتك، ولذلك نسعى جاهدين لتوفير كل ما يحتاجونه
                ليكونوا سعداء وصحيين، حيث نقدم مجموعة واسعة من المنتجات الغذائية
                والصحية بالإضافة الى مستلزمات العناية والترفيه . نحن نفتخر
                بكوننا جزء من مجتمع الحيوانات الأليفة، ونسعى لتقديم تجربة تسوق
                ممتعة ومريحة لك ولحيوانك الأليف.. شكرًا لكم على زيارتكم لمتجرنا
                الإلكتروني! نقدّر ثقتكم في خدماتنا ومنتجاتنا المتميزة لحيواناتكم
                الأليفة. نحن نسعد بفرصة خدمتكم وتلبية احتياجاتكم المتجددة. نتطلع
                دائمًا إلى رؤيتكم مجددًا، فلا تترددوا في العودة إلى متجرنا
                الإلكتروني لتجربة تسوق مميزة ورعاية متفانية لحيواناتكم الأليفة.
                إذا كان لديك أي استفسارات او اقتراحات فلا تتردد في الاتصال بنا،
                نحن هنا لمساعدتك .
              </p>
            </div>
          </section>

          {/* Mission Section */}
          <section className="bg-[linear-gradient(134deg,#fbeed4_0%,#fbeed4_50%,#ffe6b9_100%)] rounded-[20px] p-[30px] sm:p-[40px] lg:p-[50px] text-center">
            <h2 className="text-[20px] sm:text-[24px] lg:text-[32px] font-svn-gilroy font-bold leading-[28px] sm:leading-[32px] lg:leading-[40px] text-global-text8 mb-[20px] sm:mb-[30px]">
              {t("مهمتنا", { defaultValue: "مهمتنا" })}
            </h2>
            <p className="text-[14px] sm:text-[16px] lg:text-[18px] font-svn-gilroy font-medium leading-[20px] sm:leading-[24px] lg:leading-[28px] text-global-text2 max-w-[800px] mx-auto">
              نوفر لعملائنا منتجات وخدمات استثنائية تُحسّن حياتهم. نسعى جاهدين
              للتميز في كل ما نقوم به، ونبني مجتمعًا قائمًا على الثقة والابتكار
              والاستدامة.
            </p>
          </section>

          {/* Call to Action Section */}
          <section className="bg-global-text4 rounded-[20px] p-[30px] sm:p-[40px] lg:p-[50px] text-center">
            <h2 className="text-[20px] sm:text-[24px] lg:text-[32px] font-svn-gilroy font-bold leading-[28px] sm:leading-[32px] lg:leading-[40px] text-global-text8 mb-[20px] sm:mb-[30px]">
              انضم إلى رحلتنا
            </h2>
            <p className="text-[14px] sm:text-[16px] lg:text-[18px] font-svn-gilroy font-medium leading-[20px] sm:leading-[24px] lg:leading-[28px] text-global-text8 mb-[30px] sm:mb-[40px] max-w-[600px] mx-auto">
              هل أنت مستعد لمعرفة المزيد أو التواصل معنا؟ يسعدنا التواصل معك.
            </p>
            <Button
              variant="primary"
              onClick={handlePhoneClick} // Navigate to contact page
              className="bg-global-text8 text-global-text4 rounded-[8px] px-[20px] sm:px-[30px] lg:px-[40px] py-[10px] sm:py-[15px] lg:py-[20px] text-[14px] sm:text-[16px] lg:text-[18px] font-svn-gilroy font-bold"
            >
              تواصل معنا
            </Button>
          </section>
        </div>
      </div>

      {/* Include Footer at the bottom */}
      <Footer />
    </div>
  );
};

export default AboutUs;
